// extracted by mini-css-extract-plugin
module.exports = {"containerRoot":"styles_containerRoot__zsL5n","containerShareLinkIcon":"styles_containerShareLinkIcon__6SFn_"};